import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';
import ContactForm from '../../views/contacts/ContactForm';

// Rename the name of the function:
const ProjectForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'project'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        { 
            type: 'searchselect', 
            name: 'client',
            label: 'project.general.client_label',
            placeholder: 'project.general.client_placeholder',
            objectName: 'client.general.object_name.singular',
            query: {
                // Get all contacts which have the contact type 'contact', 'lead' and 'client'
                endpoint: 'get_contact_search',
                params: {
                    contact_type: ['contact', 'lead', 'client'] 
                }
            },
            selectionFormat: 'name',
            optionFormat: {
                title: { field: 'name', format: (value) => value },
                subtitle: { field: 'primary_location', format: (value) => value.address, optional: true},
            },
            addNewItem: { 
                method: 'modal-form', 
                modalForm: (currentValue) => (
                    <ContactForm searchValue={currentValue} />
                ),
            },
        },
        {
            name: 'name',
            label: 'project.general.name_label',
            type: 'text',
            placeholder: 'project.general.name_placeholder',
        },
        { 
            type: 'dropdown', 
            name: 'workflow', 
            label: 'project.general.type_label', 
            apiRequest: [{
                endpoint: 'get_workflow_list',
                object: 'workflow',
                params: { is_active: true, connected_feature: 'project' },
                useCache: true
            }],
            disabled_selected: 'project.general.type_disabled_selected',
            allowNoneOption: false,
            showSearch: false,
            orderOptions: true,
        },
        {
            type: 'date',
            name: 'start_date',
            label: 'project.general.start_date_label',
            width: '50%',
            group: 'field-row',
            helperText: 'project.general.optional_label'
        },
        {
            type: 'date',
            name: 'end_date',
            label: 'project.general.end_date_label',
            width: '50%',
            group: 'field-row',
        },
        {
            type: 'header',
        },
        { 
            type: 'dropdown', 
            name: 'billing_type', 
            label: 'project.general.billing_type_label',
            disabled_selected: 'forms.general_disabled_selected',
            defaultValue: { value: 'fixed' },
            allowNoneOption: false,
            showSearch: false,
            hardcodedOptions: [
                { value: 'fixed', name: 'project.billing_type.fixed'}, 
                { value: 'calculation', name: 'project.billing_type.calculation'}, 
                { value: 'non_billing', name: 'project.billing_type.non_billing'}, 
            ],
        },
        { 
            type: 'price-currency', 
            name: 'budget', 
            label: 'project.general.fixed_budget_label', 
            placeholder: 'project.general.budget_placeholder', 
            apiObject: 'currency',
            dependentOn: { fieldName: 'billing_type', value: 'fixed' },
        },
        {
            name: 'estimated_hours',
            label: 'project.general.calculated_hours_label',
            type: 'text',
            placeholder: 'project.general.estimated_hours_placeholder',
            dependentOn: { fieldName: 'billing_type', value: 'fixed' },
            helperText: 'project.general.optional_label'
        },
        { 
            type: 'price-currency', 
            name: 'budget', 
            label: 'project.general.budget_label', 
            placeholder: 'project.general.budget_placeholder', 
            apiObject: 'currency',
            dependentOn: { fieldName: 'billing_type', value: 'calculation' },
            tooltipText: "project.general.budget_tooltipText"
        },
        {
            name: 'estimated_hours',
            label: 'project.general.estimated_hours_label',
            type: 'text',
            placeholder: 'project.general.estimated_hours_placeholder',
            dependentOn: { fieldName: 'billing_type', value: ['calculation', 'non_billing'] },
            tooltipText: "project.general.estimated_hours_tooltipText"
        },
    ];
    
    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default ProjectForm;